import { render, staticRenderFns } from "./DetailLocation.vue?vue&type=template&id=292aa024"
import script from "./DetailLocation.vue?vue&type=script&lang=js"
export * from "./DetailLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports